var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";
import { FTLPathUtils } from "../util";
import { handleError } from "../util/error";
import { changeLocationAction, setProfileAction } from "../store/actions";
import { initialProfile } from "../store/reducers/initialState";
export default ({ children, getProfile, store }) => {
    const location = useLocation();
    const dispatch = store.dispatch;
    const [canFetchProfile, setCanFetchProfile] = useState(true);
    const currentPath = useMemo(() => FTLPathUtils.pathToArray(location.pathname)[0], [location.pathname]);
    const fetchProfile = getProfile
        ? useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const profile = (yield getProfile()).data.result;
                dispatch(setProfileAction(profile));
                setCanFetchProfile(true);
            }
            catch (error) {
                setCanFetchProfile(false);
                handleError({
                    error,
                    defaultError: "Произошла ошибка при получении данных профиля",
                });
            }
        }), [])
        : undefined;
    useEffect(() => {
        const state = store.getState();
        dispatch(changeLocationAction);
        if (fetchProfile &&
            (currentPath === "profile" ||
                (state.globalStore.profile == initialProfile &&
                    currentPath &&
                    canFetchProfile)))
            fetchProfile();
    }, [currentPath]);
    return React.createElement(Provider, { store: store }, children);
};
//# sourceMappingURL=StoreProvider.js.map